import React from "react";
import { withRouter } from "react-router-dom";

import {
  createOptionsFromStringArray,
  debouncedFetchCampaigns,
  filterCampaignsBasedOn,
  getLastMonthName,
  getNamesFromCampaignList,
  statusOptions
} from "./utils.js";

import withRefluxStore from "../../Stores/withRefluxStore.jsx";
import DashboardStore from "./DashboardStore";

import DropDownFilter from "./DropDownFilter/DropDownFilter.jsx";

import { FiltersContainer, RowWrapper, DropDownWrapper } from "./Dashboard.styled";
import { DEFAULT_STATUSES } from "./DashboardStore";
import { useTranslation } from "react-i18next";

function DashboardFilters({
  userProfile,
  isLoadingCampaigns,
  campaignList,
  // Store
  filters,
  finishedCampaignsHaveBeenLoaded,
  // Router
  history
}) {
  const { t } = useTranslation();
  filters.companies = filters.companies.filter((company) => company !== "");

  const companies = getNamesFromCampaignList(campaignList, "companyName");
  let companiesToShow = new Set([...filters.companies, ...companies]);
  companiesToShow = Array.from(companiesToShow);
  const companyOptions = createOptionsFromStringArray(companiesToShow);

  const filteredCampaignsBasedOnCompanies = filterCampaignsBasedOn({
    campaigns: campaignList,
    on: "companyName",
    selection: filters.companies
  });

  const owners = getNamesFromCampaignList(campaignList, "userName");
  const ownersBasedOnCompanies = getNamesFromCampaignList(
    filteredCampaignsBasedOnCompanies,
    "userName"
  );

  let ownersToShow = new Set([...filters.owners, ...ownersBasedOnCompanies]);
  ownersToShow = Array.from(ownersToShow);
  ownersToShow = filters.companies?.length ? ownersToShow : owners;
  const ownerOptions = createOptionsFromStringArray(ownersToShow);

  const dates = getNamesFromCampaignList(campaignList, "createdDate");
  const datesToShow = [...new Set(dates.map((date) => new Date(date).getFullYear().toString()))];

  let datesOptions = createOptionsFromStringArray(datesToShow);
  const lastMonthName = getLastMonthName();
  // eslint-disable-next-line react-i18n/no-dynamic-translation-keys
  const lastMonthOption = { value: "lastMonth", label: `Last Month (${t(lastMonthName)})` };
  const lastSixMonthsOption = { value: "lastSixMonths", label: "Last 6 Months" };
  datesOptions = [lastMonthOption, lastSixMonthsOption, ...datesOptions];

  return (
    <FiltersContainer>
      <RowWrapper>
        <DropDownWrapper paddingRight={"25px"} width={"55%"}>
          <DropDownFilter
            label={t("Campaign status")}
            placeholder={t("All statuses")}
            defaultOptionLabel={t("All current statuses")}
            defaultOptions={DEFAULT_STATUSES}
            filterKey="statuses"
            filterKeyName="Status"
            history={history}
            filters={filters}
            filterOptions={statusOptions(t)}
            userProfile={userProfile}
            finishedCampaignsHaveBeenLoaded={finishedCampaignsHaveBeenLoaded}
            isLoadingCampaigns={isLoadingCampaigns}
            debouncedFetchCampaigns={debouncedFetchCampaigns}
          />
        </DropDownWrapper>

        <DropDownWrapper paddingRight={"0"} width={"45%"}>
          <DropDownFilter
            label={t("Select Company")}
            placeholder={t("All companies")}
            filterKey="companies"
            filterKeyName={t("Company")}
            history={history}
            filters={filters}
            filterOptions={companyOptions}
            userProfile={userProfile}
            finishedCampaignsHaveBeenLoaded={finishedCampaignsHaveBeenLoaded}
            isLoadingCampaigns={isLoadingCampaigns}
            debouncedFetchCampaigns={debouncedFetchCampaigns}
          />
        </DropDownWrapper>
      </RowWrapper>
      <RowWrapper>
        <DropDownWrapper paddingRight={"25px"} width={"55%"}>
          <DropDownFilter
            label={t("Booked by")}
            placeholder={t("All owners")}
            filterKey="owners"
            filterKeyName={t("Owner")}
            history={history}
            filters={filters}
            filterOptions={ownerOptions}
            userProfile={userProfile}
            finishedCampaignsHaveBeenLoaded={finishedCampaignsHaveBeenLoaded}
            isLoadingCampaigns={isLoadingCampaigns}
            debouncedFetchCampaigns={debouncedFetchCampaigns}
          />
        </DropDownWrapper>
        <DropDownWrapper paddingRight={"0"} width={"45%"}>
          <DropDownFilter
            label={t("Time span")}
            placeholder={t("Entire period")}
            filterKey="dates"
            filterKeyName={t("Period")}
            history={history}
            filters={filters}
            filterOptions={datesOptions}
            userProfile={userProfile}
            finishedCampaignsHaveBeenLoaded={finishedCampaignsHaveBeenLoaded}
            isLoadingCampaigns={isLoadingCampaigns}
            debouncedFetchCampaigns={debouncedFetchCampaigns}
          />
        </DropDownWrapper>
      </RowWrapper>
    </FiltersContainer>
  );
}

export default withRouter(
  withRefluxStore(
    DashboardFilters,
    [DashboardStore],
    ["filters", "finishedCampaignsHaveBeenLoaded"]
  )
);
